<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Exkurs · Mobile App</p>

      <h2 class="presentation-page__title">RETIS mobile — die Plattform in der Hosentasche</h2>

      <p class="presentation-page__text">
        Jeder Monteur, jeder Projektleiter, jeder Kunde — alle arbeiten in der gleichen App.
        Offline-fähig, in Echtzeit synchronisiert.
      </p>

      <div class="presentation-page__app-columns">
        <div v-for="column in columns" :key="column.label" class="presentation-page__app-column">
          <div class="presentation-page__app-label">{{ column.label }}</div>
          <div class="presentation-page__phone-frame">
            <img
              class="presentation-page__phone-image"
              :src="column.imageSrc"
              :alt="column.imageAlt"
            />
          </div>
          <p class="presentation-page__app-text">{{ column.text }}</p>
        </div>
      </div>

      <p class="presentation-page__caption">
        Offline-fähig · iOS &amp; Android · DSGVO-konform gehostet in Deutschland
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage24',

  components: { PrintPageLandscape, PresentationPage },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      columns: [
        {
          label: 'Termin & Projekt',
          imageSrc: '/img/master_presentation/master_presentation_page_24_A.png',
          imageAlt: 'RETIS App — Termin und Projektdaten',
          text:
            'Ein Klick auf den Termin — alle Projektdaten, Aufmaß, Abnahme, Service und Zeiterfassung verfügbar.',
        },
        {
          label: 'Abnahme & Prüfung',
          imageSrc: '/img/master_presentation/master_presentation_page_24_B.png',
          imageAlt: 'RETIS App — Abnahme und Prüfung',
          text:
            'UK- und AC-Prüfungen direkt vor Ort. Status angefordert → in Prüfung → freigegeben mit Fotodokumentation.',
        },
        {
          label: 'Aufmaß & Dachdaten',
          imageSrc: '/img/master_presentation/master_presentation_page_24_C.png',
          imageAlt: 'RETIS App — Aufmaß und Dachdaten',
          text:
            'Dachtyp, Maße, Eindeckung — strukturiert erfasst, automatisch in die Auslegung übernommen.',
        },
      ],
    };
  },
};
</script>
